









































































































































































































































































import {
  FetchState,
  MfaManageStep,
  MfaStatusEnum,
  OktaFactor,
  OktaFactorProfile,
  OktaFactorType
} from "../types";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import Widget from "@/shared/components/Widget.vue";
import {
  Component,
  Vue,
  Watch
} from "@/shared/vuepack";
import MfaWidget from "@/shared/components/MfaWidget.vue";
import { Validator } from "vee-validate";
import VerificationCode from "@/employee/components/shared/VerificationCode.vue";
import { OktaSignInWidgetBuilder } from "../oktaSignInWidgetWrapper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useMfaStore } from "@/shared/store/mfa";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useOktaFactorStore } from "@/shared/store/oktaFactor";
import { useThemeStore } from "@/shared/store/theme";

// Assumes there is an empty element on the page with an id of #okta-signin-container
const widget = new OktaSignInWidgetBuilder("#okta-signin-container");

@Component({
  components: {
    MfaWidget,
    Input,
    Button,
    Widget,
    VerificationCode
  }
})
export default class OktaFactorSettings extends Vue {
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  mfaStore = useMfaStore();
  portalCustomizationStore = usePortalCustomizationStore();
  oktaFactoreStore = useOktaFactorStore();
  themeStore = useThemeStore();

  $validator: Validator;
  isSubmitting = false;
  password = "";
  token = "";
  formPhoneNumber = "";
  phoneVerificationCode = "";
  selectedMfaType: MfaStatusEnum = null;
  startingMfaType: MfaStatusEnum = null;
  isLogin = false;
  showConfirmRemoveModal = false;
  formEmail = "";
  originalEmail = "";
  emailVerificationCode = "";
  isAuthenticated = false;

  mounted (): void {
    this.oktaFactoreStore.clearState();
    this.startingMfaType = this.mfaStore.mfaStatus;
    this.selectedMfaType = this.mfaStore.mfaStatus;
    this.oktaFactoreStore.loadFactors();
  }

  get continueDisabled (): boolean {
    return (this.isAddEmailStep || this.isAddTOTPStep || this.isAddSMSStep || this.isAddVoiceCallStep)
        && (this.$validator.errors.any() || this.isSubmitting);
  }

  get emailChanged () {
    return this.formEmail !== this.originalEmail;
  }

  get submitDisabled () {
    return this.isSubmitting;
  }

  get showLoadingPage (): boolean {
    return this.isRemoveStep;
  }

  get isManageStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.Manage;
  }

  get isAuthenticateStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.Authenticate;
  }

  get isAddTOTPStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.AddTOTP;
  }

  get isAddSMSStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.AddSMS;
  }

  get isAddEmailStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.AddEmail;
  }

  get isAddVoiceCallStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.AddVoiceCall;
  }

  get isVerifyPhoneStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.VerifyPhone;
  }

  get isVerifyEmailStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.VerifyEmail;
  }

  get isRemoveStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.RemoveMFA;
  }

  get isVerifyMfaStep (): boolean {
    return this.oktaFactoreStore.step === MfaManageStep.VerifyMfa;
  }

  get confirmRemoveTitle () {
    if (!this.oktaFactoreStore.selectedFactor) {
      return "";
    }

    return `Remove ${this.oktaFactoreStore.selectedFactor.displayName}`;
  }

  get confirmRemoveMessage () {
    if (!this.oktaFactoreStore.selectedFactor) {
      return "";
    }

    return `Are you sure you want to remove ${this.oktaFactoreStore.selectedFactor.displayName} MFA?`;
  }

  factorDisplayName (displayName: string, isRequired: boolean) {
    return isRequired ? `${displayName} (required)` : displayName;
  }

  showFactorProfile (isActive: boolean, factorType: string) {
    return isActive && factorType !== OktaFactorType.Totp;
  }

  factorProfile (profile: OktaFactorProfile, factorType: string) {
    switch (factorType) {
      case OktaFactorType.Email:
        return profile.email;
      case OktaFactorType.Sms:
      case OktaFactorType.Call:
        return profile.phoneNumber;
      case OktaFactorType.Totp:
        return profile.credentialId;
    }

    return "";
  }

  onMfaValueChanged (value: boolean, key: string) {
    const factor = this.oktaFactoreStore.factors.find(f => f.key === key);
    if (!factor) {
      return;
    }

    this.oktaFactoreStore.setSelectedFactor(factor);

    if (value) {
      this.beginFactorEnrollment();
    } else {
      this.showConfirmRemoveModal = true;
    }
  }

  startProfileEdit (key: string) {
    const factor = this.oktaFactoreStore.factors.find(f => f.key === key);
    if (!factor) {
      return;
    }

    this.oktaFactoreStore.setIsEditingProfile(true);
    this.oktaFactoreStore.setSelectedFactor(factor);
    this.beginFactorEnrollment();
  }

  confirmRemove () {
    if (this.isAuthenticated) {
      this.oktaFactoreStore.removeFactor();
      return;
    }

    this.oktaFactoreStore.setStep(MfaManageStep.Authenticate);

    this.authenticate()
        .then(() => {
          this.isAuthenticated = true;
          this.oktaFactoreStore.removeFactor();
        })
        .catch(error => {
          this.notifierStore.setDanger(error);
        });
  }

  authenticate () {
    return widget
        .setUsername(this.userStore.username)
        .setBrandColor(this.themeStore.primaryColor)
        .onCustomCancelButtonClicked(() => this.cancel())
        .buildForOktaFactorSettings()
        .showSignIn();
  }

  cancelRemove () {
    if (!this.oktaFactoreStore.selectedFactor) {
      return;
    }

    this.oktaFactoreStore.revertFactorStatus(this.oktaFactoreStore.selectedFactor.key);
    this.oktaFactoreStore.setSelectedFactor(null);
  }

  beginFactorEnrollment () {
    if (this.isAuthenticated) {
      this.setEnrollmentStep();
      return;
    }

    this.oktaFactoreStore.setStep(MfaManageStep.Authenticate);

    this.authenticate()
        .then(() => {
          this.isAuthenticated = true;
          this.setEnrollmentStep();
        })
        .catch(error => {
          this.notifierStore.setDanger(error);
        });
  }

  setEnrollmentStep () {
    if (!this.oktaFactoreStore.selectedFactor) {
      return;
    }

    switch (this.oktaFactoreStore.selectedFactor.factorType) {
      case OktaFactorType.Email:
        this.oktaFactoreStore.setStep(MfaManageStep.AddEmail);
        break;
      case OktaFactorType.Sms:
        this.oktaFactoreStore.setStep(MfaManageStep.AddSMS);
        break;
      case OktaFactorType.Totp:
        this.oktaFactoreStore.setStep(MfaManageStep.AddTOTP);
        break;
      case OktaFactorType.Call:
        this.oktaFactoreStore.setStep(MfaManageStep.AddVoiceCall);
        break;
    }
  }

  @Watch("oktaFactoreStore.step")
  onStepChange () {
    switch (this.oktaFactoreStore.step) {
      case MfaManageStep.AddEmail:
        this.setFormEmail(this.oktaFactoreStore.selectedFactor.profile.email);
        break;
      case MfaManageStep.AddTOTP:
        this.oktaFactoreStore.enrollFactor();
        break;
      case MfaManageStep.AddSMS:
      case MfaManageStep.AddVoiceCall:
        this.setFormPhoneNumber(this.oktaFactoreStore.selectedFactor.profile.phoneNumber);
        break;
      case MfaManageStep.RemoveMFA:
        this.mfaStore.disableMfa(this.mfaStore.mfaStatus).then(() => {
              this.oktaFactoreStore.updateStep(MfaManageStep.Manage);
              this.notifierStore.setSuccess("Two-factor authentication has been removed from your account!");
            })
            .catch(errorText => this.notifierStore.setDanger(errorText));
        break;
      case MfaManageStep.PostMfa:
        this.postAuthStep();
        break;
    }
  }

  get formattedPhoneNumber (): string {
    return "+1" + this.formPhoneNumber.replace(/-/g, "");
  }

  postAuthStep () {
    switch (this.selectedMfaType) {
      case MfaStatusEnum.Sms:
        this.oktaFactoreStore.setStep(MfaManageStep.AddSMS);
        break;
      case MfaStatusEnum.Totp:
        this.oktaFactoreStore.setStep(MfaManageStep.AddTOTP);
        break;
      case MfaStatusEnum.Disabled:
        this.oktaFactoreStore.setStep(MfaManageStep.RemoveMFA);
        break;
    }
  }

  setFormPhoneNumber (phoneNumber: string) {
    if (phoneNumber) {
      phoneNumber = phoneNumber.replace(/^\+1/, "");
      this.formPhoneNumber = phoneNumber;
    }
  }

  setFormEmail (email: string) {
    if (email) {
      this.formEmail = email;
      this.originalEmail = email;
    }
  }

  validate (): Promise<void> {
    this.isSubmitting = true;
    return this.$validator.validateAll()
        .then(r => {
          if (!r) {
            this.isSubmitting = false;
            throw r;
          }
        });
  }

  onSubmitVerifyPhone (): Promise<void> {
    return new Promise<void>(resolve => {
      this.validate()
          .then(() => {
            this.oktaFactoreStore.activateFactor(this.phoneVerificationCode)
                .finally(() => {
                  this.phoneVerificationCode = "";
                  this.isSubmitting = false;
                  resolve();
                });
          });
    });
  }

  onSubmitVerifyTotpToken (): Promise<void> {
    return new Promise<void>(resolve => {
      this.validate().then(() => {
        this.oktaFactoreStore.activateFactor(this.token)
            .finally(() => {
              this.token = "";
              this.isSubmitting = false;
              resolve();
            });
      });
    });
  }

  onSubmitVerifyEmail (): Promise<void> {
    return new Promise<void>(resolve => {
      this.validate().then(() => {
        this.oktaFactoreStore.activateFactor(this.emailVerificationCode)
            .finally(() => {
              this.emailVerificationCode = "";
              this.isSubmitting = false;
              resolve();
            });
      });
    });
  }

  onUpdatePhoneNumberSubmit () {
    this.validate()
        .then(() => this.oktaFactoreStore.isEditingProfile ? this.oktaFactoreStore.resetFactor() : Promise.resolve())
        .then(() => this.enrollPhoneFactor());
  }

  enrollPhoneFactor () {
    return new Promise<void>(resolve => {
      this.oktaFactoreStore.enrollFactor({
            phoneNumber: this.formattedPhoneNumber
          })
          .then(response => {
            if (response && response.status !== "active") {
              this.phoneVerificationCode = "";
              this.oktaFactoreStore.setStep(MfaManageStep.VerifyPhone);
            }
          })
          .finally(() => {
            this.isSubmitting = false;
            resolve();
          });
    });
  }

  onUpdateEmailSubmit () {
    this.validate()
        .then(() => this.oktaFactoreStore.isEditingProfile ? this.oktaFactoreStore.resetFactor() : Promise.resolve())
        .then(() => this.enrollEmailFactor());
  }

  enrollEmailFactor () {
    return new Promise<void>(resolve => {
      this.oktaFactoreStore.enrollFactor({
            email: this.formEmail
          })
          .then(response => {
            if (response && response.status !== "active") {
              this.emailVerificationCode = "";
              this.oktaFactoreStore.setStep(MfaManageStep.VerifyEmail);
            }
          })
          .finally(() => {
            this.isSubmitting = false;
            resolve();
          });
    });
  }

  beforeDestroy () {
    this.revertFactorChanges();
  }

  revertFactorChanges () {
    if (this.isVerifyPhoneStep || this.isVerifyEmailStep) {
      this.oktaFactoreStore.revertFactor();
    }
  }

  cancel () {
    this.oktaFactoreStore.setIsEditingProfile(false);
    this.oktaFactoreStore.clearState();
    this.oktaFactoreStore.setFactorsLoadFetchState(FetchState.Uninitialized);
    this.oktaFactoreStore.loadFactors();
  }

}
